import { render } from "./CourseSections.vue?vue&type=template&id=101a9c42"
import script from "./CourseSections.vue?vue&type=script&lang=js"
export * from "./CourseSections.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__